import React from "react";
import { Alert } from "react-bootstrap";

const TuNhayCamWarning = ({ listTab, className }) => {
  return (
    <>
      {listTab && listTab.nhaycam && listTab.nhaycam.info && (
        <div className={`text-danger ${className}`}>
          <Alert variant="warning">
            <Alert.Heading as="h6">Có từ nhạy cảm</Alert.Heading>
            <p className="mb-0">Từ: {listTab.nhaycam.info.join(", ")}</p>
          </Alert>
        </div>
      )}
    </>
  );
};

export default TuNhayCamWarning;
